import { styles } from '../../../../utilities/styles'
import { swapAlignment } from '../../../Popover'
import { zIndexes } from '../../../../variables'
import type { Tokens } from '../../../../theming/types'
import type { TooltipUIProps } from '..'

const tooltipXOffsetMap = {
  above: 'bottom',
  below: 'top',
  before: 'right',
  after: 'left',
} as const

const tooltipYOffsetMap = {
  start: 'left',
  center: 'center',
  end: 'right',
} as const

export default (config: {
  props: Pick<TooltipUIProps, 'alignment' | 'location'> & { isRTL?: boolean }
  tokens: Tokens
}) => {
  const { props, tokens } = config
  const { alignment = 'center', location = 'above', isRTL } = props

  const tooltipXoffsetKeyword = tooltipXOffsetMap[location]
  const tooltipYoffsetKeyword =
    tooltipYOffsetMap[isRTL ? swapAlignment(alignment) : alignment]

  return {
    default: {
      tooltip: {
        ...styles.breakWord,
        ...tokens.fontBodyS,
        backgroundClip: 'padding-box',
        backgroundColor: tokens.messageBgColorDefault,
        border: `${tokens.borderWidthXS} solid ${tokens.borderColorEmphasisInverse}`,
        borderRadius: tokens.radiusSizeXS,
        boxShadow: tokens.elevationLow,
        color: tokens.fontColorInverse,
        display: 'block',
        left: 0,
        letterSpacing: 'normal',
        maxWidth: '272px',
        paddingBlock: tokens.spacingGap100,
        paddingInline: tokens.spacingGap100,
        position: 'relative',
        textAlign: 'left',
        top: 0,
        transformOrigin: `${tooltipYoffsetKeyword} ${tooltipXoffsetKeyword}`,
        whiteSpace: 'normal',
        zIndex: zIndexes.Tooltip,
      },
    },

    motionVariants: {
      tooltip: {
        initial: {
          opacity: 0,
          scale: 0.8,
        },

        enter: {
          scale: 1,
          opacity: 1,
          transition: {
            delay: 0.2,
            duration: 0.1,
            ease: 'snap',
          },
        },

        exitScale: {
          scale: 0.8,
          transition: {
            duration: 0.3,
            ease: 'default',
          },
        },

        exitOpacity: {
          opacity: 0,
          transition: {
            duration: 0.3,
            ease: 'opacity',
          },
        },
      },
    },
  } as const
}
